import {
  SET_CUSTOMER_APPOINTMENTS_LOADING,
  SET_CUSTOMER_APPOINTMENTS,
  SET_CUSTOMER_APPOINTMENT,
  SET_CUSTOMER_APPOINTMENTS_LAWYER,
  SET_CUSTOMER_APPOINTMENTS_ID,
  SET_CUSTOMER_APPOINTMENT_CALL,
  SET_CUSTOMER_SERVICE,
  SET_CUSTOMER_SERVICES,
  SET_CUSTOMER_SERVICE_ID,
  SET_CUSTOMER_MESSAGES,
  SET_CUSTOMER_APPOINTMENT_MESSAGES,
  SET_CUSTOMER_MESSAGE,
  SET_CUSTOMER_MESSAGE_ID,
  SET_CUSTOMER_AUTOCOMPLETE_LAWYERS,
  SET_CUSTOMER_AUTOCOMPLETE_SERVICES,
  SET_CUSTOMER_SERVICE_OBJ,
} from "./types";
import * as moment from "moment";
import api from "../services/Api";
import { isNullValue } from "src/helpers/common";

export const fetchCustomerAppointments =
  (id, activeTab) => async (dispatch) => {
    dispatch({ type: SET_CUSTOMER_APPOINTMENTS_LOADING, payload: true });
    try {
      //const res = await api.get(`/clients/${id}/appointments`);
      const res = await api.get(`/appointments/client/${id}`);
      let filtered = AppointmentsTabFilter(res.data.data, activeTab);

      dispatch({
        type: SET_CUSTOMER_APPOINTMENTS,
        payload: {
          callsHistory: filtered,
        },
      });
      dispatch({ type: SET_CUSTOMER_APPOINTMENTS_LOADING, payload: false });
    } catch (e) {
      dispatch({ type: SET_CUSTOMER_APPOINTMENTS_LOADING, payload: false });
    }
  };

export const AppointmentsTabFilter = (data: Array, activeTab: number) => {
  let filtered = data.filter((item) => {
    if (activeTab === 0) {
      return item.status === "Ended";
    }
    if (activeTab === 1) {
      return item.status === "Planned";
    }
    return false;
  });

  return filtered.sort((a, b) => moment(b.start) - moment(a.start));

  // return _.filter(data, filters.like)
};

export const fetchCustomerAppointment = (id) => async (dispatch) => {
  try {
    let res = null;
    let resMessages = null;
    let resLawyer = null;
    let resService = null;

    res = await api.get(`/appointments/${id}`);

    if (res) {
      resMessages = await api.get(`/messages/appointments/${id}`);

      if (res.data.data.lawyerId)
        resLawyer = await api.get(`/lawyers/${res.data.data.lawyerId}`);

      if (res.data.data.serviceId)
        resService = await api.get(`/services/${res.data.data.serviceId}`);
    }

    dispatch({
      type: SET_CUSTOMER_APPOINTMENT,
      payload: {
        appointment: res ? res.data.data : null,
        appointmentLawyer: resLawyer ? resLawyer.data.data : null,
        appointmentMessages: resMessages ? resMessages.data.data : null,
        appointmentService: resService ? resService.data.data : null,
      },
    });
  } catch (e) {}
};

export const fetchCustomerAppointmentLawyer = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/lawyers/${id}`);

    let resPrice: any = [];
    if (res) {
      resPrice = await api.get(`/lawyers/${id}/services`);
    }
    if (
      typeof res.data.data !== "undefined" &&
      typeof resPrice.data.data !== "undefined"
    ) {
      res.data.data.price = resPrice.data.data[0].price;
      res.data.data.services = resPrice.data.data;
    }

    dispatch({
      type: SET_CUSTOMER_APPOINTMENTS_LAWYER,
      payload: {
        appointmentLawyer: res.data.data,
      },
    });
  } catch (e) {}
};

export const fetchCustomerAppointmentMessages = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/messages/appointments/${id}`);

    dispatch({
      type: SET_CUSTOMER_APPOINTMENT_MESSAGES,
      payload: {
        appointmentMessages: res.data.data,
      },
    });
  } catch (e) {}
};

export const getMessageDetailsRequest = (id, isTrash) => async (dispatch) => {
  try {
    //alert(id);

    let message = null;
    let resService = null;
    let resLawer = null;
    let lastStage = null;
    let messageRequest = await api.get(`/messages/${id}`);

    if (messageRequest) {
      if (messageRequest.data.data.length > 0) {
        message = messageRequest.data.data[0];
        if (isTrash) {
          message.isTrash = true;
        }
        if (!message.isRead) {
          api.put(`/messages/${message.id}/setIsRead`);
        }
      }
      if (message) {
        if (message.serviceId) {
          resService = await api.get(`/services/${message.serviceId}`);
          if (resService) {
            if (resService.data.data.stages.length > 0) {
              //alert('dddd');
              lastStage = resService.data.data.stages.find(
                ({ type }) => type === "Płatność"
              );
            }
            if (resService.data.data.lawyerId) {
              resLawer = await api.get(
                `/lawyers/${resService.data.data.lawyerId}`
              );
            }
          }
        }
      }
    }

    dispatch({
      type: SET_CUSTOMER_MESSAGE,
      payload: {
        message: message,
        lawyer: resLawer ? resLawer.data.data : null,
        service: resService ? resService.data.data : null,
        lastStage: lastStage,
      },
    });
  } catch (e) {}
};

export const fetchCustomerService = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/services/${id}`);
    let resLawyer = null;
    let resAppointment = null;
    let lastStage = null;
    let wycena = null;
    let completed = null;
    const requestMessagesList = await api.get(`/messages/services/${id}`);
    resAppointment = await api.get(`/services/${id}/appointments`);

    if (requestMessagesList.data.data) {
      wycena = requestMessagesList.data.data.find(
        ({ topic }) => topic === "Wycena"
      );
      completed = requestMessagesList.data.data.find(({ type }) => type === 3);
      if (wycena === undefined) {
        wycena = null;
      }
      if (completed === undefined) {
        completed = null;
      }
    }

    if (res) {
      if (res.data.data.lawyerId) {
        resLawyer = await api.get(`/lawyers/${res.data.data.lawyerId}`);
      }
      if (res.data.data.stages.length) {
        lastStage = res.data.data.stages.find(
          ({ type }) => type === "Płatność"
        );
        if (lastStage === undefined) {
          lastStage = null;
        }
      }
    }

    dispatch({
      type: SET_CUSTOMER_SERVICE,
      payload: {
        lastStage: lastStage,
        wycena: wycena,
        completed: completed,
        activeServiceObj: res ? res.data.data : null,
        serviceMessages: requestMessagesList
          ? requestMessagesList.data.data
          : null,
        appointmentLawyer: resLawyer ? resLawyer.data.data : null,
        serviceAppointment: resAppointment
          ? resAppointment.data.data.sort(
              (a, b) => moment(b.start) - moment(a.start)
            )
          : null,
      },
    });
  } catch (e) {}
};

export const readMessagePromise = (id) => {
  return api.put(`/messages/${id}/setIsRead`);
};

export const fetchAutocompleteServices = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/clients/${id}/services`);

    if (res.data.success)
      dispatch({
        type: SET_CUSTOMER_AUTOCOMPLETE_SERVICES,
        payload: {
          autocompleteServices: res.data.data,
        },
      });
  } catch (e) {}
};

export const fetchAutocompleteLawyers = (id) => async (dispatch) => {
  try {
    const res = await api.get(`/clients/${id}/lawyers`);
    const resSec = await api.get(`/secretary/all`);

    const secretaries = resSec.data.data.map((sec) => {
      return { ...sec, User: { id: sec.userId } };
    });

    if (res.data.success)
      dispatch({
        type: SET_CUSTOMER_AUTOCOMPLETE_LAWYERS,
        payload: {
          autocompleteLawyers: [...res.data.data, ...secretaries],
        },
      });
  } catch (e) {}
};

export const setServiceValuation = (id, status) => async (dispatch) => {
  try {
    var data = {
      isAccept: status,
    };
    const res = await api.put(`/services/items/${id}`, data);
    dispatch({
      type: SET_CUSTOMER_SERVICE,
      payload: {
        isAccept: res.data.data,
      },
    });
  } catch (e) {}
};

export const setActiveMessageId = (id) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER_MESSAGE_ID, payload: id });

  if (!id) {
    dispatch({
      type: SET_CUSTOMER_MESSAGE,
      payload: {
        message: null,
        lawyer: null,
        service: null,
        lastStage: null,
      },
    });
  }
};

export const setAppointmentsId = (id: string) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER_APPOINTMENTS_ID, payload: id });

  if (!id) {
    dispatch({
      type: SET_CUSTOMER_APPOINTMENT,
      payload: {
        appointment: null,
        appointmentLawyer: null,
        appointmentMessages: null,
        appointmentService: null,
      },
    });
  }
};

export const setAppointmentCall = (obj) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER_APPOINTMENT_CALL, payload: obj });
};

export const fetchCustomerServices =
  (customerId, activeTab) => async (dispatch) => {
    try {
      const res = await api.get(`/clients/${customerId}/services`);
      let filtered = ServicesTabFilter(res.data.data, activeTab);

      dispatch({
        type: SET_CUSTOMER_SERVICES,
        payload: {
          serviceHistory: filtered,
        },
      });
    } catch (e) {}
  };

export const ServicesTabFilter = (data: Array, activeTab: number) => {
  if (activeTab === 0) return data;

  return data.filter((item) => {
    if (activeTab === 1) {
      return item.status === "Otwarte";
    }
    if (activeTab === 2) {
      return item.status === "Zamknięte";
    }
    return false;
  });

  // return _.filter(data, filters.like)
};

export const fetchCustomerMessages = () => async (dispatch) => {
  try {
    let trash = [];
    const resRecived = await api.get(`/messages/received`);
    const resSent = await api.get(`/messages/sent`);
    const resTrash = await api.get(`/messages/trash`);

    if (resTrash.data.data) {
      trash = resTrash.data.data
        .map((msg) => {
          msg.isTrash = true;
          return msg;
        })
        .sort((a, b) => b.id - a.id);
    }

    let messages: any[] = [];

    messages = messages.concat(resRecived.data.data);
    messages = messages.concat(resSent.data.data);

    messages.sort((a, b) => b.id - a.id);

    const recieved = resRecived.data.data
      ? resRecived.data.data.sort((a, b) => b.id - a.id)
      : [];
    const sent = resSent.data.data
      ? resSent.data.data.sort((a, b) => b.id - a.id)
      : [];

    dispatch({
      type: SET_CUSTOMER_MESSAGES,
      payload: {
        messages: messages,
        messagesRecived: recieved,
        messagesSent: sent,
        messagesTrash: trash,
      },
    });
  } catch (e) {}
};

export const setCustomerServiceId = (obj) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER_SERVICE_ID, payload: obj });
};
export const setCustomerServiceObj = (obj) => (dispatch) => {
  dispatch({ type: SET_CUSTOMER_SERVICE_OBJ, payload: obj });
};
